import { gikClassPrefix } from '@gik/core/constants';
import classNames from 'classnames';
import React from 'react';

const blockName = `${gikClassPrefix}-inkind-thumbnail`;

interface IInkindThumbnailProps {
  thumbnail: string;
  isOrganizer: boolean;
}

export default function InkindThumbnail({ thumbnail, isOrganizer }: IInkindThumbnailProps): React.ReactElement {
  return (
    <div
      className={classNames([{ [blockName]: true }, { [`${blockName}--organizer`]: isOrganizer }])}
      style={
        thumbnail
          ? {
              backgroundImage: `url(${thumbnail})`,
            }
          : {}
      }
    />
  );
}
